import type { RJSFSchema, UiSchema } from "@rjsf/utils";
import { baseJsonSchema, baseUiSchema } from "@/views/cms/EditorView/mediaSchemas/baseMediaSchema";

const tempJson = JSON.parse(JSON.stringify(baseJsonSchema)) as RJSFSchema;
export const model3dJsonSchema: RJSFSchema = tempJson;

const tempUi = JSON.parse(JSON.stringify(baseUiSchema)) as UiSchema;
tempUi["ui:order"] = ["general", "metaData", "credits"];
export const model3dUiSchema: UiSchema = tempUi;
